import { PayloadAction } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';
import { put, takeLatest } from 'redux-saga/effects';
import {
  IGetLenderPoliciesPayload,
  getLenderPoliciesRequestFailed,
  getLenderPoliciesRequestSucceeded,
  getLenderPoliciesRequested,
} from 'redux/slice/settings/Compliance/GetLenderPolicies.slice';
import {
  IComplianceResponse,
  ILenderPolicy,
} from 'redux/types/Compliance.types';
import { settingsEndpoints } from 'services/api/endPoints';
import { HTTPClient } from 'services/api/http-client';
import { v4 as uuidv4 } from 'uuid';

function* getLenderPoliciesSaga({
  payload,
}: PayloadAction<IGetLenderPoliciesPayload>) {
  const { region, entityId, offset, limit } = payload;
  const requestId = uuidv4();
  try {
    const response: AxiosResponse<IComplianceResponse<ILenderPolicy>> =
      yield HTTPClient.PostRequest(
        settingsEndpoints.GET_ALL_POLICIES,
        { region, lenderId: entityId, pageSize: limit, pageOffset: offset },
        { headers: { 'request-id': requestId } }
      );
    const responseData = { ...response.data.data, limit, offset };
    yield put(getLenderPoliciesRequestSucceeded(responseData));
  } catch (err) {
    yield put(
      getLenderPoliciesRequestFailed({ error: { message: 'Error' } } as any)
    );
  }
}

export function* watchGetLenderPoliciesSaga() {
  yield takeLatest(getLenderPoliciesRequested.type, getLenderPoliciesSaga);
}
